import React from "react";
import LoginRegister from "./LoginRegister";

const Login = () => {
  return (
    <section className="login-section auth-page">
      <div className="image-layer"></div>
      <div className="outer-box">
        <LoginRegister mode="login" />
      </div>
    </section>
  );
};

export default Login;
